/* 🤖 this file was generated by svg-to-ts */
import { SbIcons } from './sb-icons.model';
import { sbIconsApps } from './sbIcons-apps.icon';
import { sbIconsArrowDown } from './sbIcons-arrow-down.icon';
import { sbIconsArrowLeft } from './sbIcons-arrow-left.icon';
import { sbIconsArrowRight } from './sbIcons-arrow-right.icon';
import { sbIconsArrowUp } from './sbIcons-arrow-up.icon';
import { sbIconsBabyCarriage } from './sbIcons-baby-carriage.icon';
import { sbIconsBalanceScale } from './sbIcons-balance-scale.icon';
import { sbIconsBan } from './sbIcons-ban.icon';
import { sbIconsBandAid } from './sbIcons-band-aid.icon';
import { sbIconsBars } from './sbIcons-bars.icon';
import { sbIconsBell } from './sbIcons-bell.icon';
import { sbIconsBolt } from './sbIcons-bolt.icon';
import { sbIconsBook } from './sbIcons-book.icon';
import { sbIconsBuilding } from './sbIcons-building.icon';
import { sbIconsCalculator } from './sbIcons-calculator.icon';
import { sbIconsCalendarCheck } from './sbIcons-calendar-check.icon';
import { sbIconsCalendarDay } from './sbIcons-calendar-day.icon';
import { sbIconsCalendarGroup } from './sbIcons-calendar-group.icon';
import { sbIconsCalendarMonth } from './sbIcons-calendar-month.icon';
import { sbIconsCalendarSlash } from './sbIcons-calendar-slash.icon';
import { sbIconsCalendarTimes } from './sbIcons-calendar-times.icon';
import { sbIconsCalendarWeek } from './sbIcons-calendar-week.icon';
import { sbIconsCalendar } from './sbIcons-calendar.icon';
import { sbIconsCamera } from './sbIcons-camera.icon';
import { sbIconsCarSideview } from './sbIcons-car-sideview.icon';
import { sbIconsCelebrate } from './sbIcons-celebrate.icon';
import { sbIconsChartLine } from './sbIcons-chart-line.icon';
import { sbIconsCheckCircleSolid } from './sbIcons-check-circle-solid.icon';
import { sbIconsCheckCircle } from './sbIcons-check-circle.icon';
import { sbIconsCheck } from './sbIcons-check.icon';
import { sbIconsChevronDown } from './sbIcons-chevron-down.icon';
import { sbIconsChevronLeft } from './sbIcons-chevron-left.icon';
import { sbIconsChevronRight } from './sbIcons-chevron-right.icon';
import { sbIconsChevronUp } from './sbIcons-chevron-up.icon';
import { sbIconsCircle } from './sbIcons-circle.icon';
import { sbIconsClipboard } from './sbIcons-clipboard.icon';
import { sbIconsClock } from './sbIcons-clock.icon';
import { sbIconsCoffee } from './sbIcons-coffee.icon';
import { sbIconsComment } from './sbIcons-comment.icon';
import { sbIconsCopy } from './sbIcons-copy.icon';
import { sbIconsCreditCard } from './sbIcons-credit-card.icon';
import { sbIconsDownload } from './sbIcons-download.icon';
import { sbIconsDraggabledots } from './sbIcons-draggabledots.icon';
import { sbIconsEllipsisH } from './sbIcons-ellipsis-h.icon';
import { sbIconsEllipsisV } from './sbIcons-ellipsis-v.icon';
import { sbIconsEmail } from './sbIcons-email.icon';
import { sbIconsEuroCircle } from './sbIcons-euro-circle.icon';
import { sbIconsExchangeHorizontal } from './sbIcons-exchange-horizontal.icon';
import { sbIconsExchangeVertical } from './sbIcons-exchange-vertical.icon';
import { sbIconsExclamationCircleSolid } from './sbIcons-exclamation-circle-solid.icon';
import { sbIconsExclamationCircle } from './sbIcons-exclamation-circle.icon';
import { sbIconsExclamationTriangle } from './sbIcons-exclamation-triangle.icon';
import { sbIconsExternalLink } from './sbIcons-external-link.icon';
import { sbIconsEyeSlash } from './sbIcons-eye-slash.icon';
import { sbIconsEye } from './sbIcons-eye.icon';
import { sbIconsFile } from './sbIcons-file.icon';
import { sbIconsFilter } from './sbIcons-filter.icon';
import { sbIconsFlag } from './sbIcons-flag.icon';
import { sbIconsFuture } from './sbIcons-future.icon';
import { sbIconsHistory } from './sbIcons-history.icon';
import { sbIconsHospital } from './sbIcons-hospital.icon';
import { sbIconsHouse } from './sbIcons-house.icon';
import { sbIconsInfoCircle } from './sbIcons-info-circle.icon';
import { sbIconsKid } from './sbIcons-kid.icon';
import { sbIconsLayerGroup } from './sbIcons-layer-group.icon';
import { sbIconsLifebuoy } from './sbIcons-lifebuoy.icon';
import { sbIconsLockOpen } from './sbIcons-lock-open.icon';
import { sbIconsLock } from './sbIcons-lock.icon';
import { sbIconsMapMarkerSlash } from './sbIcons-map-marker-slash.icon';
import { sbIconsMapMarker } from './sbIcons-map-marker.icon';
import { sbIconsMedkit } from './sbIcons-medkit.icon';
import { sbIconsMegaphone } from './sbIcons-megaphone.icon';
import { sbIconsMinus } from './sbIcons-minus.icon';
import { sbIconsMoneyInsert } from './sbIcons-money-insert.icon';
import { sbIconsMoneyWithdraw } from './sbIcons-money-withdraw.icon';
import { sbIconsNotepad } from './sbIcons-notepad.icon';
import { sbIconsPaperPlane } from './sbIcons-paper-plane.icon';
import { sbIconsPaperclip } from './sbIcons-paperclip.icon';
import { sbIconsPen } from './sbIcons-pen.icon';
import { sbIconsPercentageSquare } from './sbIcons-percentage-square.icon';
import { sbIconsPercentage } from './sbIcons-percentage.icon';
import { sbIconsPhone } from './sbIcons-phone.icon';
import { sbIconsPlaneDeparture } from './sbIcons-plane-departure.icon';
import { sbIconsPlane } from './sbIcons-plane.icon';
import { sbIconsPlusMinus } from './sbIcons-plus-minus.icon';
import { sbIconsPlus } from './sbIcons-plus.icon';
import { sbIconsPuzzlePiece } from './sbIcons-puzzle-piece.icon';
import { sbIconsQuestionCircle } from './sbIcons-question-circle.icon';
import { sbIconsQuestion } from './sbIcons-question.icon';
import { sbIconsRedo } from './sbIcons-redo.icon';
import { sbIconsRefresh } from './sbIcons-refresh.icon';
import { sbIconsRepeat } from './sbIcons-repeat.icon';
import { sbIconsSearch } from './sbIcons-search.icon';
import { sbIconsSetting } from './sbIcons-setting.icon';
import { sbIconsShieldExclamation } from './sbIcons-shield-exclamation.icon';
import { sbIconsSignAlt } from './sbIcons-sign-alt.icon';
import { sbIconsSlidersV } from './sbIcons-sliders-v.icon';
import { sbIconsSort } from './sbIcons-sort.icon';
import { sbIconsStar } from './sbIcons-star.icon';
import { sbIconsStars } from './sbIcons-stars.icon';
import { sbIconsStopwatch } from './sbIcons-stopwatch.icon';
import { sbIconsStructure } from './sbIcons-structure.icon';
import { sbIconsSuitcase } from './sbIcons-suitcase.icon';
import { sbIconsTachometer } from './sbIcons-tachometer.icon';
import { sbIconsTarget } from './sbIcons-target.icon';
import { sbIconsTimesCircle } from './sbIcons-times-circle.icon';
import { sbIconsTimes } from './sbIcons-times.icon';
import { sbIconsToggle } from './sbIcons-toggle.icon';
import { sbIconsTrash } from './sbIcons-trash.icon';
import { sbIconsUpload } from './sbIcons-upload.icon';
import { sbIconsUserCheck } from './sbIcons-user-check.icon';
import { sbIconsUserTimes } from './sbIcons-user-times.icon';
import { sbIconsUser } from './sbIcons-user.icon';
import { sbIconsUsers } from './sbIcons-users.icon';
import { sbIconsUtensils } from './sbIcons-utensils.icon';
import { sbIconsWindsock } from './sbIcons-windsock.icon';
export const completeIconSet: SbIcons[] = [
  sbIconsApps as SbIcons,
  sbIconsArrowDown as SbIcons,
  sbIconsArrowLeft as SbIcons,
  sbIconsArrowRight as SbIcons,
  sbIconsArrowUp as SbIcons,
  sbIconsBabyCarriage as SbIcons,
  sbIconsBalanceScale as SbIcons,
  sbIconsBan as SbIcons,
  sbIconsBandAid as SbIcons,
  sbIconsBars as SbIcons,
  sbIconsBell as SbIcons,
  sbIconsBolt as SbIcons,
  sbIconsBook as SbIcons,
  sbIconsBuilding as SbIcons,
  sbIconsCalculator as SbIcons,
  sbIconsCalendarCheck as SbIcons,
  sbIconsCalendarDay as SbIcons,
  sbIconsCalendarGroup as SbIcons,
  sbIconsCalendarMonth as SbIcons,
  sbIconsCalendarSlash as SbIcons,
  sbIconsCalendarTimes as SbIcons,
  sbIconsCalendarWeek as SbIcons,
  sbIconsCalendar as SbIcons,
  sbIconsCamera as SbIcons,
  sbIconsCarSideview as SbIcons,
  sbIconsCelebrate as SbIcons,
  sbIconsChartLine as SbIcons,
  sbIconsCheckCircleSolid as SbIcons,
  sbIconsCheckCircle as SbIcons,
  sbIconsCheck as SbIcons,
  sbIconsChevronDown as SbIcons,
  sbIconsChevronLeft as SbIcons,
  sbIconsChevronRight as SbIcons,
  sbIconsChevronUp as SbIcons,
  sbIconsCircle as SbIcons,
  sbIconsClipboard as SbIcons,
  sbIconsClock as SbIcons,
  sbIconsCoffee as SbIcons,
  sbIconsComment as SbIcons,
  sbIconsCopy as SbIcons,
  sbIconsCreditCard as SbIcons,
  sbIconsDownload as SbIcons,
  sbIconsDraggabledots as SbIcons,
  sbIconsEllipsisH as SbIcons,
  sbIconsEllipsisV as SbIcons,
  sbIconsEmail as SbIcons,
  sbIconsEuroCircle as SbIcons,
  sbIconsExchangeHorizontal as SbIcons,
  sbIconsExchangeVertical as SbIcons,
  sbIconsExclamationCircleSolid as SbIcons,
  sbIconsExclamationCircle as SbIcons,
  sbIconsExclamationTriangle as SbIcons,
  sbIconsExternalLink as SbIcons,
  sbIconsEyeSlash as SbIcons,
  sbIconsEye as SbIcons,
  sbIconsFile as SbIcons,
  sbIconsFilter as SbIcons,
  sbIconsFlag as SbIcons,
  sbIconsFuture as SbIcons,
  sbIconsHistory as SbIcons,
  sbIconsHospital as SbIcons,
  sbIconsHouse as SbIcons,
  sbIconsInfoCircle as SbIcons,
  sbIconsKid as SbIcons,
  sbIconsLayerGroup as SbIcons,
  sbIconsLifebuoy as SbIcons,
  sbIconsLockOpen as SbIcons,
  sbIconsLock as SbIcons,
  sbIconsMapMarkerSlash as SbIcons,
  sbIconsMapMarker as SbIcons,
  sbIconsMedkit as SbIcons,
  sbIconsMegaphone as SbIcons,
  sbIconsMinus as SbIcons,
  sbIconsMoneyInsert as SbIcons,
  sbIconsMoneyWithdraw as SbIcons,
  sbIconsNotepad as SbIcons,
  sbIconsPaperPlane as SbIcons,
  sbIconsPaperclip as SbIcons,
  sbIconsPen as SbIcons,
  sbIconsPercentageSquare as SbIcons,
  sbIconsPercentage as SbIcons,
  sbIconsPhone as SbIcons,
  sbIconsPlaneDeparture as SbIcons,
  sbIconsPlane as SbIcons,
  sbIconsPlusMinus as SbIcons,
  sbIconsPlus as SbIcons,
  sbIconsPuzzlePiece as SbIcons,
  sbIconsQuestionCircle as SbIcons,
  sbIconsQuestion as SbIcons,
  sbIconsRedo as SbIcons,
  sbIconsRefresh as SbIcons,
  sbIconsRepeat as SbIcons,
  sbIconsSearch as SbIcons,
  sbIconsSetting as SbIcons,
  sbIconsShieldExclamation as SbIcons,
  sbIconsSignAlt as SbIcons,
  sbIconsSlidersV as SbIcons,
  sbIconsSort as SbIcons,
  sbIconsStar as SbIcons,
  sbIconsStars as SbIcons,
  sbIconsStopwatch as SbIcons,
  sbIconsStructure as SbIcons,
  sbIconsSuitcase as SbIcons,
  sbIconsTachometer as SbIcons,
  sbIconsTarget as SbIcons,
  sbIconsTimesCircle as SbIcons,
  sbIconsTimes as SbIcons,
  sbIconsToggle as SbIcons,
  sbIconsTrash as SbIcons,
  sbIconsUpload as SbIcons,
  sbIconsUserCheck as SbIcons,
  sbIconsUserTimes as SbIcons,
  sbIconsUser as SbIcons,
  sbIconsUsers as SbIcons,
  sbIconsUtensils as SbIcons,
  sbIconsWindsock as SbIcons
];
